import {
  PROMOTION_WITH_CUSTOMER_TYPE_ALL,
  PROMOTION_WITH_CUSTOMER_TYPE_CREATE,
  PROMOTION_WITH_CUSTOMER_TYPE_GET,
  PROMOTION_WITH_CUSTOMER_TYPE_UPDATE,
  PROMOTION_WITH_CUSTOMER_TYPE_DELETE,
} from '../../actions/types';

const initialState = {
  serials: null,
  isLoading: true,
  isCompleted: false,
};
export default function (state = initialState, action) {
  switch (action.type) {
    case PROMOTION_WITH_CUSTOMER_TYPE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PROMOTION_WITH_CUSTOMER_TYPE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case PROMOTION_WITH_CUSTOMER_TYPE_CREATE:
      return { isLoading: true, isCompleted: true };
    case PROMOTION_WITH_CUSTOMER_TYPE_UPDATE:
      return { isLoading: true, isCompleted: true };
    case PROMOTION_WITH_CUSTOMER_TYPE_DELETE:
      return { isLoading: true, isCompleted: true };
    default:
      return state;
  }
}
